module.exports = __webpack_public_path__ + "static/media/select-file-icon.54022796.svg";